import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-e092ac52")

_pushScopeId("data-v-e092ac52")
const _hoisted_1 = { class: "page-footer-main" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 page-footer" }
const _hoisted_5 = { class: "footer-text" }
const _hoisted_6 = { class: "footer-text-wrap" }
const _hoisted_7 = { class: "links" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "gap" }, null, -1)
const _hoisted_9 = { class: "copyright" }
const _hoisted_10 = { class: "footer-logo" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("span", null, [
                  _createVNode("a", {
                    class: "link-1",
                    target: "blank",
                    href: _ctx.termsUrl
                  }, "Terms of Use", 8, ["href"])
                ]),
                _hoisted_8,
                _createVNode("span", null, [
                  _createVNode("a", {
                    class: "link-2",
                    target: "blank",
                    href: _ctx.privacyUrl
                  }, "Privacy Policy", 8, ["href"])
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("small", null, "© Copyright " + _toDisplayString(_ctx.currentYear) + " - The Law Society of New South Wales (ABN 98 696 304 966, ACN 000 000 699)", 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("img", {
              class: "logo",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.logoClick())),
              src: _imports_0,
              alt: "Footer logo",
              title: "The Law Society Of New South Wales"
            })
          ])
        ])
      ])
    ])
  ]))
})